module.exports = __webpack_public_path__ + "img/metropolitan_hospital_logo.8eb1a93e.svg";